const CURRENT_USER = "customer_token";
const LANG = "customer_language";

export class Utils {
  static setToken(token: string) {
    localStorage.setItem(CURRENT_USER, token);
  }

  static getToken(): string | null {
    return localStorage.getItem(CURRENT_USER);
  }

  static removeToken() {
    localStorage.removeItem(CURRENT_USER);
  }

  static getLanguage() {
    return localStorage.getItem(LANG) || "en";
  }

  static setLanguage(lang: string) {
    localStorage.setItem(LANG, lang);
  }

  static downloadBlob(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
